import { Alert } from "@mui/material";
import { useRole } from "hooks/useRole";

// NS-753
//ReadOnlyNotice tells a user whose role cannot change the policy that the
//editor only shows the item. It renders nothing for a role that can edit.
export function ReadOnlyNotice() {
    const { canEditPolicy } = useRole();

    if (canEditPolicy) {
        return null;
    }

    return <Alert id="read-only-notice" severity="info" sx={{ marginTop: "10px" }}>
        Read-only role: you can view this item but not change it.
    </Alert>;
}

export default ReadOnlyNotice;
